import { Attributes, ModelBase, NeoModel, Rules, Validation } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateCorporateActionEventTransactionsPriceCommand extends ModelBase {
    public corporateActionEventId: number = 0;

    @Rules.Required()
    @Attributes.Float()
    public priceOverride: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.priceOverride !== null && c.priceOverride <= 0, "The price override must be greater than zero.");

    }
}